import Vue from 'vue';
import bridge from '@common/bridge';
import App from '@common/App';
import router from '@common/router';
import store from '@common/store';
import types from '@common/store/system/types';
import '@common/assets/css/base.css';
// import '@common/assets/css/jquerysctipttop.css';
// import bus from '@utils/bus';
import login from '@utils/login';
import verify from '@common/utils/verify';
// eslint-disable-next-line import/extensions
import toastMessage from '@common/utils/customPlugin/toast.js';
import ImageViewer from 'vue2-viewer';
// eslint-disable-next-line import/extensions
// import $ from 'jquery';
import '@utils/jquery_reflection';
import '@utils/jquery_cloud9carousel';
import ElementUI from 'element-ui';
import Fingerprint2 from 'fingerprintjs2';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

Vue.use(ImageViewer);

Vue.use(toastMessage);
Vue.config.devtools = process.env.NODE_ENV !== 'production';
Vue.config.productionTip = false;
Vue.config.silent = process.env.NODE_ENV === 'production';
Vue.prototype.$verify = verify;
Vue.prototype.$bridge = bridge;
Vue.prototype.$toastMessage = toastMessage;

/* eslint-disable*/
// if (process.env.NODE_ENV !== 'production') {
//     const Vconsole = require('vconsole');
//     new Vconsole();
// }
//const Vconsole = require('vconsole');
//new Vconsole();
/* eslint-disable*/
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        setTimeout(() => {
            document.title = to.meta.title;
        }, 20);
    }
    if (bridge.isApp && !store.state.system.authorization) {
        bridge
            .getAuthorization()
            .then((res) => {
                if (res.token) {
                    store.dispatch(types.authorization, res.token || '');
                    //store.dispatch(types.deviceId, res.deviceId || '');
                    login(to.path).then(() => {
                        next();
                    });
                } else {
                    if (to.meta.title !== '集卡领红包') {
                        bridge.toLogin();
                    }
                    next();
                }
            })
            .catch(next);
    } else {
        login(to.path).then(() => {
            next();
        });
    }
});

// bus.register(router, store);

//初始化设备id
  Fingerprint2.get(function(components) {
    const values = components.map(function(component,index) {
      if (index === 0) { //把微信浏览器里UA的wifi或4G等网络替换成空,不然切换网络会ID不一样
        return component.value.replace(/\bNetType\/\w+\b/, '');
      }
      return component.value;
    })
    // 生成最终id  
    const deviceId = Fingerprint2.x64hash128(values.join(''), 31);
    store.commit(types.deviceId, deviceId);
    Start();
  });

 
 function Start(){ 
    new Vue({
        router,
        store,
        render: (h) => h(App),
    }).$mount('#app');
 }